import { useState, useEffect } from 'react';

export const useElementHeight = (elementRef) => {
  const [elementHeight, setElementHeight] = useState(0);

  useEffect(() => {
    if (!elementRef) return;
    if (!elementRef.current) return;

    setElementHeight(elementRef.current.clientHeight);

    const handleResize = () => 
    setElementHeight(elementRef.current.clientHeight);
    

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [elementRef]);

  return elementHeight;
};
